import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';

function FlexContainerColumn(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      noFlexGrow = _ref.noFlexGrow,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "noFlexGrow"]);

  return React.createElement("div", _extends({}, rest, {
    className: clsx(classes.root, className, !noFlexGrow && classes.grow)
  }), children);
}

FlexContainerColumn.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    grow: PropTypes.string,
    root: PropTypes.string
  }).isRequired,
  className: PropTypes.string,
  noFlexGrow: PropTypes.bool
};
FlexContainerColumn.defaultProps = {
  children: null,
  className: undefined,
  noFlexGrow: false
};
export default withStyles({
  root: {
    display: 'flex',
    flexFlow: 'column'
  },
  grow: {
    flexGrow: 1
  }
}, {
  name: 'SxFlexContainerColumn'
})(FlexContainerColumn);